<template>
  <v-card v-model="previewModal" color="white" min-width="350px" max-width="350px" min-height="200px" flat v-bind="$attrs"
    v-on="$listeners">
    <v-toolbar color="white" class="elevation-0" height="60px" :class="{ 'mb-6': eventImg != '' }">
      <!-- <v-icon class="pa-3" color="white">{{ icon }}</v-icon> -->
      <v-spacer></v-spacer>
      <v-btn icon small class="pa-1" @click="editFunction" v-if="!eventConfidential || eventOwner">
        <v-icon color="black">{{ edit }}</v-icon>
      </v-btn>
      <!-- <v-btn icon>
        <v-icon color="white">mdi-dots-vertical</v-icon>
      </v-btn> -->
      <v-btn icon small class="pa-1" v-bind="attrs" @click="closeFunction">
        <v-icon color="black">mdi-close</v-icon>
      </v-btn>

      <div class="v-card__img" v-if="eventImg != ''">
        <img :src="eventImg" alt="" />
      </div>
    </v-toolbar>

    <v-card-title class="card-title font-weight-bold py-2 " :class="{ 'event-cancelled': eventCancelled }">
      {{ title }}
    </v-card-title>
    <v-card-text class="card-text" v-html="details" v-if="!eventConfidential || eventOwner">
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'EdnPreviewModal',
  data: () => ({

  }),
  props: {
    // icon: {
    //   type: String,
    //   default: () => 'mdi-heart'
    // },
    title: {
      type: String,
      default: () => ''
    },
    eventImg: {
      type: String,
      default: () => ''
    },
    eventCancelled: {
      type: Boolean,
      default: () => false
    },
    eventConfidential: {
      type: Boolean,
      default: () => false
    },
    eventOwner: {
      type: Boolean,
      default: () => false
    },
    edit: {
      type: String,
      default: () => 'mdi-pencil'
    },
    details: {
      type: String,
      default: () => ''
    },
    nTab: [{
      type: [Array, Object],
      default: () => []
    }],
    nFileId: [{
      type: [Array, Object],
      default: () => []
    }],
    closeOnContentClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  methods: {
    editFunction() {
      this.$emit('createEdit', { nTab: this.nTab, nFileId: this.nFileId });
    },

    closeFunction() {
      this.$emit('closeModal');
    }

  },
}
</script>
<style lang="scss">
.card-title.event-cancelled {
  text-decoration: line-through 3px;
}

.v-card__info {
  padding: 6px 0;
  margin: 0 !important;
}

.v-card__info:first-child {
  padding-top: 0;
}

.v-card__img {
  position: absolute;
  transform: translate(-50%, 50%);
  left: 50%;
  width: 60px;
  height: 60px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: white;
  border-radius: 4px;
  border: 3px solid white;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12) !important;
}

.v-card__img img {
  width: 100%;
  height: 100%;
}

.card-title,
.card-text {
  font-family: 'Roboto', sans-serif;
}
</style>
